import ArrowRightAlt from "@material-ui/icons/ArrowRightAlt";
import TabPane from "Components/Tabview/Tabpane/TabPane";
import * as React from "react";
import styles from "./Tabview.scss";
import { TabviewMode } from "./TabviewMode";

interface IProps {
    children: React.ReactNode[];
    className?: string;
    selectedItem: string;
    tabviewMode: TabviewMode;
    onChange: (key: string | number) => void;
}

interface IState {
    selectedIndex: number;
}

class Tabview extends React.Component<IProps, IState> {
    private tabviewModeClassName: string = "";

    constructor(props: IProps) {
        super(props);

        let selectedIndex = 0;
        this.props.children.forEach((child, i) => {
            if ((child as TabPane).props.value === this.props.selectedItem) {
                selectedIndex = i;
            }
        });

        this.tabviewModeClassName = props.tabviewMode === TabviewMode.Horizontal ? styles.horizontal : styles.vertical;
        this.state = {
            selectedIndex
        };
    }

    public selectItem(index: number, child: React.ReactNode) {
        const tabPane = child as TabPane;
        this.props.onChange(tabPane.props.value);
        this.setState({ selectedIndex: index });
    }

    public isSelected(index: number): boolean {
        return this.state.selectedIndex === index;
    }

    public render() {

        return (
            <div className={`${styles.tabview} ${this.tabviewModeClassName} ${this.props.className}`}>
                <div className={`${styles.tabTitles} ${this.tabviewModeClassName}`}>
                    {
                        this.props.children.map((child, i) => {
                            return (
                                <div key={(child as TabPane).props.value + "_title"} id={child!.props.id} className={`${styles.title} ${this.tabviewModeClassName} ${this.isSelected(i) ? styles.selected : null}`} onClick={() => this.selectItem(i, child)}>
                                    {(child! as TabPane).props.title} {this.props.tabviewMode === TabviewMode.Vertical ? <ArrowRightAlt className={styles.icon} /> : null}
                                </div>
                            );
                        })
                    }
                </div>
                <div className={styles.tabContent}>
                    {
                        this.props.children.map((child, i) => {
                            return (
                                <div key={(child as TabPane).props.value} className={`${styles.tabPane} ${this.isSelected(i) ? styles.visible : null} `}>
                                    {child}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}

export default Tabview;


// WEBPACK FOOTER //
// ./src/Components/Tabview/Tabview.tsx